<!--
  Created 15.10.2023
  Simple StringWrapperLink component, with two different styles
  Switches between showing a "show more" or "show less" link depending on the state of the showAll prop
-->
<template>
  <template v-if="isSimple">
    <a
      v-if="!showAll"
      class="ml-2 cursor-pointer underline opacity-50 hover:opacity-100 whitespace-nowrap"
      @click.prevent="$emit('showAll', true)">Les mer</a>
    <a
      v-else
      class="mt-4 block cursor-pointer text-xs underline opacity-50 hover:opacity-100 whitespace-nowrap"
      @click.prevent="$emit('showAll', false)">Minimer tekst</a>
  </template>
  <template v-else>
    <a
      v-if="!showAll"
      class="mt-8 block cursor-pointer text-sm opacity-50 hover:opacity-100 whitespace-nowrap"
      @click.prevent="$emit('showAll', true)">
      <PlusSmallIcon class="mr-1 inline-block h-5 w-5" />
      <span class="underline">Vis mer av teksten</span>
    </a>
    <a
      v-else
      class="mt-8 block cursor-pointer text-sm opacity-50 hover:opacity-100 whitespace-nowrap"
      @click.prevent="$emit('showAll', false)">
      <MinusSmallIcon class="mr-1 inline-block h-5 w-5" />
      <span class="underline">Vis mindre av teksten</span></a>
  </template>
</template>

<script setup>
import {
  computed,
  ref,
} from 'vue';
import {
  PlusSmallIcon, MinusSmallIcon,
} from '@heroicons/vue/24/solid';

const props = defineProps({
  showAll: {
    type: Boolean,
    required: false,
    default: false,
  },
  isSimple: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const showAll = computed(() => props.showAll);

defineEmits(['showAll']);

</script>
